import React from 'react';
import PropTypes from 'prop-types';
import { Map } from 'immutable';

import TextBlock from '../../TextBlock';
import FileUpload from '../../ui/FileUpload';
import StyledDropzone from '../../ui/StyledDropzone';
import IconUploadType from '../../ui/IconUploadType';

import Wrapper from './Wrapper';
import VideoContent from './VideoContent';
import VideoDescription from './VideoDescription';

const ALLOWED_MIME_TYPES = ['video/mp4', 'video/x-m4v', 'video/quicktime', 'video/*'].join(',');

class Video extends React.PureComponent {
  handleChangeDescription = (value) => {
    this.props.onChangeBlockField(value, 'description');
  }

  render() {
    const src = this.props.block.getIn(['video', 'path']);

    return (
      <Wrapper>
        {!this.props.block.get('uploading') && (
          <React.Fragment>
            {src ? (
              <VideoContent src={src} onButtonClick={this.props.onRemoveMedia} />
            ) : (
              <FileUpload>
                <StyledDropzone
                  className="uploadDropZone"
                  accept={ALLOWED_MIME_TYPES}
                  minSize={1024}
                  multiple={false}
                  onDrop={this.props.onDropFile}
                >
                  <div className="uploadType">
                    <IconUploadType />

                    <div>Загрузить <br /> с компьютера</div>
                  </div>
                </StyledDropzone>
              </FileUpload>
            )}

            <VideoDescription>
              <TextBlock
                block={this.props.block}
                fieldName="description"
                placeholder="Добавьте описание к видео"
                onChange={this.handleChangeDescription}
              />
            </VideoDescription>
          </React.Fragment>
        )}
      </Wrapper>
    );
  }
}

Video.propTypes = {
  block: PropTypes.instanceOf(Map).isRequired,

  onChangeBlockField: PropTypes.func,
  onRemoveMedia: PropTypes.func,
};

Video.defaultProps = {
  onChangeBlockField: () => {},
  onRemoveMedia: () => {},
};

export default Video;
